export const Footer = () => (
  <div className="fixed bottom-6 left-1/2 flex w-full max-w-[390px] -translate-x-1/2 -translate-y-1/2 flex-col items-center gap-[22px] text-xs text-[#4a5466]">
    <div className="text-center leading-5 [&_a]:text-inherit">
      By proceeding you acknowledge that you have read, understood and agree to
      our <a href="https://www.porchpass.com/terms">Terms and Conditions</a>.
    </div>
    <div className="flex flex-row justify-between gap-6 [&_a]:text-inherit">
      <a href="https://www.porchpass.com/privacy">Privacy</a>
      <a href="https://www.porchpass.com/contact">Support</a>
      <span>© 2025 PorchPass Inc.</span>
    </div>
  </div>
);
